var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"panel",staticClass:"w-95 pl-5"},[_c('div',{staticClass:"row w-100 justify-content-start"},[_c('div',{staticStyle:{"width":"calc(100vw - 50px)","height":"calc(100vh - 20px)"}},[_c('matrix',{attrs:{"groupData":_vm.streamings,"panelWidth":_vm.panelWidth}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }